module.exports = __webpack_public_path__ + "media/images/faces/face18-14cdd0c2aa5571571f16f053228a4d4e.jpg";